import { makeStyles } from "@material-ui/core";

export const dwellWidgetStyle = makeStyles((theme) => ({
    tooltip: {
        padding: '0.5em 1em',
        background: '#fff',
        borderRadius: '5px',
        boxShadow: '2px 3px 10px #d7d6d6',
    },
    graphTootltip: {
        background: theme.palette.background.paper,
        padding: '10px 0.8em',
        boxShadow: theme.shadows[3],
        maxWidth: '9rem'
    },
    lotAddress: {
        fontSize: 10
    },
    lotContainer: {
        paddingLeft: '1em'
    },
    filterIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    "recharts-cartesian-axis-ticks":
    {
        display: 'none'
    },
    tableIconWrapper: {
        padding: '1rem 0 0 0',
    },
    singleLotCard: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem 1.5rem',
        gap: '0.5rem',
    },
    singleLotCount: {
        fontSize: '6rem',
        fontWeight: 800,
        color: theme.palette.primary.dark,
        lineHeight: 1,
    },
    singleLotLabel: {
        fontSize: 16,
        color: theme.palette.text.secondary,
    },
    singleLotDivider: {
        width: '100%',
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: '0.5rem 0',
    },
    singleLotBreakdownRow: {
        fontSize: 15,
        fontWeight: 600,
    },
}));